import { isAxiosError } from 'axios'

/**
 * The server's explanation for a request it refused (4xx), such as "You already belong to
 * another RxPad organisation." Server errors (5xx), network failures and responses without a
 * text message return undefined, so callers fall back to their own generic text.
 */
export const getRequestErrorMessage = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) return undefined
  const status = error.response?.status
  if (!status || status < 400 || status >= 500) return undefined
  const message = (error.response?.data as { message?: unknown } | undefined)?.message
  return typeof message === 'string' && message.trim() ? message : undefined
}
